import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Select, Typography, message, Spin } from 'antd';
import { PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { addSiteRequest } from '../../../redux/actions/siteActions';  
import { fetchProvinceTypesRequest } from '../../../redux/actions/provinceActions'; 
import '../style.css';

const { Option } = Select;
const { Title } = Typography;

const EmployeeForm = () => {
  const dispatch = useDispatch();

  // Get loading, error, and success data for the site creation from Redux state
  const { loading, error, siteAdded } = useSelector((state) => state.site);

  // Get province types data from Redux state
  const { provinceTypes, provinceLoading } = useSelector((state) => state.provinceType);

  const [formData, setFormData] = useState({
    corporationno: '',
    sitename: '',
    address: '',
    city: '',
    provinceid: '',
    postalcode: '',
    phone: '',
    email: '',
    website: '',
  });

  

  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchProvinceTypesRequest());
  }, [dispatch]);

  useEffect(() => {
    // alert("Running")
    //console.log("useEfect running", siteAdded)
    if (siteAdded) {
      message.success("Site Added Successfully")
      // Reset the form data on successful submission
      setFormData({
        corporationno: '',
        sitename: '',
        address: '',
        city: '',
        provinceid: '',
        postalcode: '',
        phone: '',
        email: '',
        website: '',
      });
      setErrors({}); // Reset errors after successful submit
    }

    if (error) {
      message.error(`Error: ${error}`);
    }
  }, [siteAdded, error]); // Reset form on data or error change

  const handleChange = (changedField) => {
    setFormData((prev) => ({ ...prev, ...changedField }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.corporationno) newErrors.corporationno = 'Corporation number is required.';
    if (!formData.sitename) newErrors.sitename = 'Site name is required.';
    if (!formData.address) newErrors.address = 'Address is required.';
    if (!formData.city) newErrors.city = 'City is required.';
    if (!formData.provinceid) newErrors.provinceid = 'Province  is required.';
    if (!formData.phone) newErrors.phone = 'Phone is required.';
    if (!formData.email) newErrors.email = 'Email is required.';
    if (!formData.postalcode) newErrors.postalcode = 'PostalCode is required.';
    return newErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
  
    if (Object.keys(validationErrors).length === 0) {
      try {
        // Dispatch the action to add the site
        dispatch(addSiteRequest(formData)); 
  
        // if(!loading && siteAdded===true)
        //   {
        //     message.success('Site added successfully!');
        //     setFormData({
        //   corporationno: '',
        //   sitename: '',
        //   address: '',
        //   city: '',
        //   provinceid: '',
        //   postalcode: '',
        //   phone: '',
        //   email: '',
        //   website: '',
        // });
        // setErrors({});
        //   }
      } catch (error) {
        // If there’s an error, display the error message (catch error passed from saga)
        if (error.response && error.response.data) {
          message.error(error.response.data.message || 'An error occurred while adding the site.');
        } else {
          message.error('An unexpected error occurred.');
        }
      }
    } else {
      message.error('Please correct the errors in the form.');
    }
  };
  

  return (
    <Spin spinning={loading}>
      <div className="formclass">
        <Title level={3} className="form-title">
          Site Registration
        </Title>

        <Form
          name="site_form"
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={formData}
          className="employee-form"
        >
          {/* Row 1: Corporation Number and Site Name */}
          <Row gutter={16}>
           
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Sitename" required>
                <Input 
                  size="large" 
                  value={formData.sitename} 
                  onChange={(e) => handleChange({ sitename: e.target.value })}
                />
                {errors.sitename && <span className="error">{errors.sitename}</span>}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Corporation Number" required>
                <Input 
                  size="large" 
                  value={formData.corporationno} 
                  onChange={(e) => handleChange({ corporationno: e.target.value })}
                />
                {errors.corporationno && <span className="error">{errors.corporationno}</span>}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Email" required>
                <Input 
                  size="large" 
                  value={formData.email} 
                  onChange={(e) => handleChange({ email: e.target.value })}
                  prefix={<MailOutlined />} 
                />
                {errors.email && <span className="error">{errors.email}</span>}
              </Form.Item>
            </Col>
          </Row>

          {/* Row 2: Address, City, Phone */}
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Address" required>
                <Input 
                  size="large" 
                  value={formData.address} 
                  onChange={(e) => handleChange({ address: e.target.value })}
                />
                {errors.address && <span className="error">{errors.address}</span>}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="City" required>
                <Input 
                  size="large" 
                  value={formData.city} 
                  onChange={(e) => handleChange({ city: e.target.value })}
                />
                {errors.city && <span className="error">{errors.city}</span>}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Phone" required>
                <Input 
                  size="large" 
                  value={formData.phone} 
                  onChange={(e) => handleChange({ phone: e.target.value })}
                  prefix={<PhoneOutlined />} 
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
              </Form.Item>
            </Col>
          </Row>

          {/* Row 3: Province, Postal Code */}
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Province" required>
                
                <Select 
                  size="large"
                  value={formData.provinceid}
                  dropdownStyle={{ maxHeight: 200 }}
                  listHeight={200}
                  showSearch 
                  optionFilterProp="children" 
                  filterOption={(input, option) =>
                    (option?.children || '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => handleChange({ provinceid: value })}
                  loading={provinceLoading}
                >
                  {provinceTypes?.map((province) => (
                    <Option key={province.id} value={province.id}>
                      {province.province}
                    </Option>
                  ))}
                </Select>
                {errors.provinceid && <span className="error">{errors.provinceid}</span>}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Postal Code"  required>
                <Input 
                  size="large" 
                  value={formData.postalcode} 
                  onChange={(e) => handleChange({ postalcode: e.target.value })}
                />
                 {errors.postalcode && <span className="error">{errors.postalcode}</span>}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Website">
                <Input 
                  size="large" 
                  value={formData.website} 
                  onChange={(e) => handleChange({ website: e.target.value })}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Submit Button */}
          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              block 
              loading={loading}
              style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Spin>
  );
};

export default EmployeeForm;


